import React, { useEffect, useRef, useState } from "react";
import { Button, Card, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import assured from "../../assets/assuredflipcart.jpg";
import { useAuth } from "../../contexts/AuthContext";
import { LuShoppingCart } from "react-icons/lu";
import { FaLongArrowAltDown } from "react-icons/fa";
import "./index.css";
import img1 from "../../../src/assets/img1.jpg";
const ProductCard = ({ item }) => {
  const navigate = useNavigate();
  const containerRef = useRef(null);
  const {
    whiteListProducts,
    handleSetWhiteListProducts,
    setSingleProduct,
    cartProducts,
    handleSetCartProducts,
    handleShowCart,
  } = useAuth();

  const [randomRatingCount, setRandomRatingCount] = useState(0);
  useEffect(() => {
    const generateRandomRating = () => {
      const min = 100;
      const max = 5000;
      return Math.floor(Math.random() * (max - min + 1)) + min;
    };
    setRandomRatingCount(generateRandomRating());
  }, []);

  const handleRedirect = (id) => {
    navigate(`/single-product/${id}`);
  };

  const [rowHeight, setRowHeight] = useState(null);

  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      const aspectRatio = img.naturalWidth / img.naturalHeight;

      const cardWidth = containerRef.current?.offsetWidth || 200;
      const computedHeight = Math.max(150, Math.round(cardWidth / aspectRatio));

      const rowIndex = Math.floor(
        (Array.from(
          containerRef.current?.parentElement?.parentElement?.children || []
        ).indexOf(containerRef.current?.parentElement) || 0) / 2
      );
      const key = `rowHeight_${rowIndex}`;
      if (!sessionStorage.getItem(key)) {
        sessionStorage.setItem(key, computedHeight);
      }

      const h = sessionStorage.getItem(key);
      setRowHeight(parseInt(h || computedHeight));
    };
    img.src = item?.images[0] ?? "";
  }, [item?.images[0]]);

  return (
    <Col
      // xxl={2}
      // xl={3}
      // lg={3}
      // md={3}
      // sm={4}
      // xs={6}
      key={item._id}
      // style={{ maxHeight: 400 }}
    >
      <Card
        style={{
          height: "100%",
          borderRadius: "12px",
          overflow: "hidden",
          border: "1px solid #e5e5e5",
        }}
        onClick={() => {
          setSingleProduct(item);
          handleRedirect(item._id);
        }}
      >
        <div
          className="position-relative"
          style={{
            height: "calc(100% - 150px)",
            height: rowHeight || 220,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#fafafa",
          }}
          ref={containerRef}
        >
          <div
            style={{
              position: "absolute",
              left: "0px",
              bottom: "-9px",
              background: "#fff",
              borderRadius: "9999px",
              padding: "2px 8px",
              display: "inline-flex",
              alignItems: "center",
              gap: "2px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              fontSize: "12px",
              fontWeight: 600,
              color: "#212121",
            }}
          >
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              {Number(item?.rating ?? 4.0).toFixed(1)}
              <i
                className="fa-solid fa-star"
                style={{ fontSize: "10px", color: "#1C1C1C" }}
              />
            </span>
            <span style={{ color: "#6b7280" }}>|</span>
            <span style={{ color: "#6b7280" }}>{randomRatingCount}</span>
          </div>

          {/*  Wishlist Icon */}
          <div
            className="position-absolute"
            style={{
              top: "10px",
              right: "10px",
              width: "32px",
              height: "32px",
              borderRadius: "50%",
              background: "#fff",
              border: "1px solid #e6e6e6",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
            }}
            onClick={(e) => {
              e.stopPropagation();
              handleSetWhiteListProducts(item);
            }}
          >
            {whiteListProducts?.find((o) => o._id === item._id) ? (
              <svg width="18" height="18" viewBox="0 0 24 24" fill="#ed143d">
                <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
              </svg>
            ) : (
              <svg width="18" height="18" viewBox="0 0 24 24" fill="#3E4152">
                <path d="M16.5 3C14.76 3 13.09 3.81 12 5.09 10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zM12 19.55l-.1-.1C7.14 15.24 4 12.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5 18.5 5 20 6.5 20 8.5c0 3.89-3.14 6.74-7.9 10.95l-.1.1z" />
              </svg>
            )}
          </div>

          <Card.Img
            variant="top"
            src={item?.images[0] ?? ""}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </div>

        <Card.Body className="p-2 pb-2" style={{ backgroundColor: "#fafafa" }}>
          <Card.Text
            style={{
              fontSize: "14px",
              fontWeight: "600",
              letterSpacing: "0.5px",
              marginBottom: "6px",
              marginTop: "6px",
              textTransform: "uppercase",
              fontFamily: "'Poppins', sans-serif",
            }}
          >
            {item?.vendor}
          </Card.Text>

          <Card.Subtitle
            style={{
              textAlign: "left",
              color: "#6b7280",
              fontWeight: "500",
              fontSize: "13px",
              lineHeight: "1.3",
              fontFamily: "'Poppins', sans-serif",
            }}
            className="mb-0 text-ellips mb-2"
          >
            {item.title}
          </Card.Subtitle>

          <Card.Text
            className="mb-1"
            style={{
              display: "flex",
              alignItems: "baseline",
              gap: "6px",
              marginTop: "4px",
            }}
          >
            <span
              style={{
                backgroundColor: "#10b981",
                color: "#fff",
                fontSize: "12px",
                fontWeight: 700,
                borderRadius: "3px",
                padding: "3px 3px",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                lineHeight: 1,
                gap: "0px",
              }}
            >
              <FaLongArrowAltDown
                style={{
                  fontSize: "15px",
                  marginBottom: "0px",
                  paddingTop: "4px",
                  marginRight: "-4px",
                }}
              />
              {`${(((item?.price - item.discount) / item?.price) * 100).toFixed(
                0
              )}%`}
            </span>

            <span
              style={{
                fontSize: "12px",
                color: "#878787",
                textDecoration: "line-through",
              }}
            >
              ₹{item.price}
            </span>
            <span
              style={{
                fontSize: "14px",
                fontWeight: 700,
                color: "#000",
              }}
            >
              ₹{item.discount}
            </span>
          </Card.Text>

          <Card.Text
            className="mb-0"
            style={{
              fontSize: "11px",
              color: "#212121",
              fontWeight: "500",
              fontFamily: "'Poppins', sans-serif",
            }}
          >
            <span
              style={{
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                color: "#fff",
                fontWeight: "700",
                borderRadius: "4px",
                padding: "2px 6px",
                marginRight: "6px",
                fontSize: "11px",
                display: "inline-block",
              }}
            >
              WOW
            </span>
            ₹{Math.max(1, item.discount - 7)} with Bank offer
          </Card.Text>
        </Card.Body>

        <Card.Footer className="px-2 py-0 bg-white border-0 pt-0 mb-1">
          <Button
            className="w-100 d-flex align-items-center justify-content-center"
            variant="dark"
            style={{
              backgroundColor: process.env.REACT_APP_THEAM_COLOR,
              border: "none",
            }}
            onClick={(e) => {
              e.stopPropagation();
              const existingProduct = cartProducts?.find(
                (o) => o._id === item._id
              );
              if (!existingProduct) {
                const updatedCart = [
                  ...cartProducts,
                  {
                    ...item,
                    quantity: 1,
                    ...(item.size &&
                      item.size.length > 0 && { selectSize: item.size[0] }),
                  },
                ];
                handleSetCartProducts(updatedCart);
              }

              e.target.classList.add("bounceIn");
              setTimeout(() => {
                e.target.classList.remove("bounceIn");
              }, 1000);
              handleShowCart();
            }}
          >
            <LuShoppingCart />
            <span className="ms-2">Add To Cart</span>
          </Button>
        </Card.Footer>
      </Card>
    </Col>
  );
};

export default ProductCard;
